const createBulkSnapshots = require('../../../shipment/shipment-bulk-create-snapshots')
const { VALIDATION_REMARKS } = require('./../../../order/tools/validate-planning')
const tools = require('../../tools')
const closeOrders = require('./close').close
const get = require('lodash/get')

exports.confirmGroup = confirmGroup
async function confirmGroup (
  state, mainApi, {groupId, dryRun = false}, {excludedOrders = [], excludedDestinationIds = [], notMappedProducts = [], productsWithNoPrice = [], orderSellPrices = {}, relatedProducts = []} = {}
) {
  const closedAt = new Date().toJSON()
  const excludedViaLoanBalanceOnly = excludedOrders.filter(order => {
    return order.remark === VALIDATION_REMARKS.failed
  })
  const snapshots = (
    await state.dal.order.getGroup(state, {groupId, onlyIncompleteSnaps: true})
  ).filter(snapshot => {
    const excludedForLoanBalance = excludedViaLoanBalanceOnly.some(order => (order._id === snapshot._id) || (order.groupId === snapshot.groupId && order.destinationId === snapshot.destinationId))
    return !excludedForLoanBalance && !excludedDestinationIds.includes(snapshot.destinationId)
  })

  const productIdsToDelete = productsWithNoPrice.concat(notMappedProducts.map(product => product._id))
  snapshots.forEach(snapshot => {
    productIdsToDelete.forEach(id => {
      delete snapshot.products[id]
    })
  })
  if (!snapshots.length) {
    return []
  }

  // The mainApi.product.listAll() is too expensive, it grabs every product in the system, including unrelated products to the services involved in an order
  // In the online order confirmation endpoint, we already fetch the products related to locations involved in orders in a given order group
  // If such products are provided we use that as opposed to making a call to the product.listAll()
  const products = relatedProducts && relatedProducts.length > 0 ? relatedProducts : await mainApi.product.listAll()
  // Get default packpoint for territory
  const destinationId = get(snapshots[0], `destinationId`)
  const orderType = get(snapshots[0], `orderType`)

  const destination = await mainApi.location.get(destinationId)
  const membershipType = destination.membership
  const [ defaultSupplier ] = await mainApi.order.getSupplierIdsForLocation(destination, {planType: orderType})

  const destinationSnapshots = tools.createDestinationShipments({
    orderSnapshots: snapshots,
    closedAt,
    products,
    defaultSupplier,
    membershipType,
    orderSellPrices
  })
  if (dryRun) {
    return destinationSnapshots
  }

  const shipments = await createBulkSnapshots(state, destinationSnapshots)
  const closedResponse = await closeOrders(state, {groupId, closedAt, closedStatus: 'confirmed'})
  return {shipments, closedResponse}
}
